// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.article {
  min-height: 200px;
  border: 1px solid transparent;
  border-radius: 2px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: border-color 0.2s ease;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1490196078);
}
.article.selected {
  border-color: var(--ion-color-primary);
}
.article ion-img {
  margin: 0 auto;
  height: 50px;
}
.article .name {
  color: #000;
  margin: 8px 0 auto;
}
.article .price {
  font-family: AppFontBold, sans-serif;
  color: #000;
  font-size: 14px;
  margin: 0 0 10px;
}
.article .quantity-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.article .quantity-block .button {
  width: 28px;
  height: 28px;
  cursor: pointer;
}
.article .quantity-block .button.black {
  --icon-color: black;
}
.article .quantity-block .quantity {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  min-width: 20px;
  text-align: center;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/app/components/extra-option-modal/extra-option-article/extra-option-article.component.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;;AAEA;EACC,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,wDAAA;AACD;AACC;EACC,sCAAA;AACF;AAEC;EACC,cAAA;EACA,YAAA;AAAF;AAGC;EACC,WAAA;EACA,kBAAA;AADF;AAIC;EACC,oCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAFF;AAKC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAHF;AAKE;EACC,WAAA;EACA,YAAA;EACA,eAAA;AAHH;AAKG;EACC,mBAAA;AAHJ;AAOE;EACC,eAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AALH","sourcesContent":[":host {\n\tdisplay: block;\n}\n\n.article {\n\tmin-height: 200px;\n\tborder: 1px solid transparent;\n\tborder-radius: 2px;\n\tpadding: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\ttext-align: center;\n\ttransition: border-color 0.2s ease;\n\tbox-shadow: 0px 0px 15px 0px #00000026;\n\n\t&.selected {\n\t\tborder-color: var(--ion-color-primary);\n\t}\n\n\tion-img {\n\t\tmargin: 0 auto;\n\t\theight: 50px;\n\t}\n\n\t.name {\n\t\tcolor: #000;\n\t\tmargin: 8px 0 auto;\n\t}\n\n\t.price {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: #000;\n\t\tfont-size: 14px;\n\t\tmargin: 0 0 10px;\n\t}\n\n\t.quantity-block {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 8px;\n\n\t\t.button {\n\t\t\twidth: 28px;\n\t\t\theight: 28px;\n\t\t\tcursor: pointer;\n\n\t\t\t&.black {\n\t\t\t\t--icon-color: black;\n\t\t\t}\n\t\t}\n\n\t\t.quantity {\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 600;\n\t\t\tmargin: 0;\n\t\t\tmin-width: 20px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #000;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
